import React from "react";
import PropTypes from "prop-types";

import ExportButton from "../../ExportButton";

function callEvent(name) {
  const evt = document.createEvent("Event");
  evt.initEvent(name, true, false);
  window.dispatchEvent(evt);
}

const Add = () => (
  <span className="dropdown">
    <button
      type="button"
      className="btn btn-pink btn-raised btn-long dropdown-toggle margin-right-five hidden-xs hidden-sm"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      ADD
      <span className="caret" />
    </button>

    <ul className="dropdown-menu" aria-labelledby="add">
      <li>
        <a
          href="javascript:void(0);"
          onClick={() => {
            callEvent("openModalToAddSaiCertificate");
          }}
        >
          ADD SAI CERTIFICATION
        </a>
      </li>
    </ul>
  </span>
);

const Options = ({ locationId, active, saiAdminPortal }) => (
  <span className="dropdown">
    <button
      type="button"
      className="btn btn-grey btn-raised btn-long dropdown-toggle hidden-xs hidden-sm"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      OPTIONS
      <span className="caret" />
    </button>

    <ul className="dropdown-menu" aria-labelledby="options">
      <li>
        <ExportButton
          url={"/export/sai_certifications?export_all_sai_accounts=" + saiAdminPortal}
        />
      </li>
    </ul>
  </span>
);

const SaiActions = ({ locationId, active, saiAdminPortal }) => (
  <div className="pull-right">
    <Add />

    <Options
      locationId={locationId}
      active={active}
      saiAdminPortal={saiAdminPortal}
    />
  </div>
);

SaiActions.propTypes = {
  locationId: PropTypes.string,
  active: PropTypes.oneOf(["string", "number"]),
  accountIsSai: PropTypes.bool
};

export default SaiActions;
